module.exports = __webpack_public_path__ + "img/jellyfish.ce2eb8eb.svg";